import { type } from '@ngrx/signals'
import { eventGroup } from '@ngrx/signals/events'

import type { BoostMessageResponse } from '@app/modules/messaging/models/api.model'
import type { Conversation } from '@app/modules/messaging/models/conversation.model'
import type { Message } from '@app/modules/messaging/models/message.model'

import type { MessageBoostType } from '../models/message-boost-type'

export const boostEvents = eventGroup({
  source: 'Boost',
  events: {
    boost: type<{
      message: Message
      messageBoostType: MessageBoostType
      profile_id: number
    }>(),
    boostSuccess: type<{
      response: BoostMessageResponse
      message: Message
      conversation: Conversation
    }>(),
    boostFailure: type<{
      error: any
      profile_id: number
    }>(),
    boostEnd: type<{ messageTimestamp: Message['timestamp'] }>(),
  },
})
